import React from 'react';

const CalendarLargeSVG = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 17C12 16.4477 12.4477 16 13 16H17C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H13C12.4477 18 12 17.5523 12 17Z"
        fill="#969FA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H18C20.2091 4 22 5.79086 22 8V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V8C2 5.79086 3.79086 4 6 4H7V3C7 2.44772 7.44772 2 8 2ZM15 6V7C15 7.55228 15.4477 8 16 8C16.5523 8 17 7.55228 17 7V6H18C19.1046 6 20 6.89543 20 8V10H4V8C4 6.89543 4.89543 6 6 6H7V7C7 7.55228 7.44772 8 8 8C8.55228 8 9 7.55228 9 7V6H15ZM4 12V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12H4Z"
      />
    </svg>
  );
};

export default CalendarLargeSVG;
